import { Component, Event, EventEmitter, h, Host, Prop } from '@stencil/core';

@Component({
  tag: 'checkbox-component',
  styleUrl: 'checkbox-component.scss',
  shadow: true,
})
export class CheckboxComponent {
  @Prop({ reflect: true, mutable: true }) label: string;
  @Prop({ reflect: true, mutable: true }) checked: boolean;
  @Prop({ reflect: true, mutable: true }) value: string | undefined;

  @Prop() checkboxLabel?: string = '';
  @Prop() checkboxPrice?: string = '';
  @Prop() checkboxHelperText?: string = '';
  @Prop() checkboxErrorMessage?: string = '';
  @Prop() isError: boolean = false;
  @Prop() isDisabled: boolean = false;
  @Prop() isSmallButton: boolean = false;
  @Event() valueChanged: EventEmitter<string>;

  render() {
    let descr: string;
    if (this.isError) {
      descr = this.checkboxErrorMessage;
    } else {
      descr = this.checkboxHelperText;
    }
    return (
      <Host>
        <div
          class={`box ${this.isSmallButton ? 'small' : ''} ${this.isDisabled ? 'disabled' : ''} ${this.isError ? 'error' : ''} ${!this.isDisabled && !this.isError ? 'default' : ''} ${this.checked ? 'checked' : ''}`}
          tabindex="0"
        >
          <div class="row">
            <label class="selector">
              {this.checked ? <span class="checkbox material-icons-sharp check-sym checked">check</span> : <span class="checkbox material-icons-sharp check-sym"></span>}
            </label>
            <div class="title">{this.checkboxLabel}</div>
            <div class="price">{this.checkboxPrice}</div>
          </div>
          <div class={'description'}>
            {this.isError && <span class="material-icons-outlined">error</span>}
            {descr}
          </div>
        </div>
        <div class="background"></div>
      </Host>
    );
  }
}
